
import StringHelpers from './StringHelpers'
export default class {
    
    static randomInt (max) {
        if(!max)
            max = 10
        return Math.floor(Math.random() * max) + 1
    }

    static randomIntRange(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    static isNumeric(n) {
        return !isNaN(parseFloat(n)) && isFinite(n)
    }

    static numbersFromString(str) {
        return str.replace(/[^\d.-]/g, '')
    }

    static abbreviateNumber(number) {
        number = parseInt(number)

        if(number % 1000 > 0)
            return StringHelpers.formatNumber(number)

        if(number >= 1000000)
            return (Math.round(number / 1000) / 1000).toString() + 'm'
        if(number >= 1000)
            return (Math.round(number / 100) / 10).toString() + 'k'
        return number
    }

    static isEven(n) {
        n = Number(n)
        return n === 0 || !!(n && !(n%2))
    }
      
    static isOdd(n) {
        return this.isEven(Number(n) + 1)
    }
}


// WEBPACK FOOTER //
// ./src/helpers/NumberHelpers.js